export enum ETenantUrls {
  TENANT_PROFILE = 'profile',
  ONBOARD = 'onboard',
  DETAILS = 'details',
  PROFILE_PICTURE = 'profile-picture',
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'phone',
  ANIMAL_METADATA = 'animal-metadata',
  SA = 'sa',
  PROPERTIES = 'properties',
  ANIMALS = 'animals',
  REGISTER = 'register',
  DUPLICATIONS = 'duplications',
  ATTACH_TO = 'attach-to',
  AGREEMENT = 'agreement',
  ACKNOWLEDGE = 'acknowledge',
}
